import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';
import { ConfigurationProfile } from '@rocksoft/mdm-sdk-v2';

export function selectConfigurationProfileId(profile: ConfigurationProfile) {
  return `${profile.udid}-${profile.payloadIdentifier}`;
}

export const adapter: EntityAdapter<ConfigurationProfile> = createEntityAdapter<ConfigurationProfile>({
  selectId: selectConfigurationProfileId,
});

export type AppleProfileState = EntityState<ConfigurationProfile>;

export const initialState: AppleProfileState = adapter.getInitialState();
